import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: true,
    supportedLngs: ['en', 'de', 'fr', 'nl'],
    interpolation: {
      escapeValue: false
    },
    backend: {
      loadPath: '/locale/{{lng}}/{{ns}}.json'
    },
    detection: {
      order: ['queryString', 'cookie'],
      caches: ['cookie']
    }
  });

export default i18n;